import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles/enums';
import { combineLatest, Observable, filter, map } from 'rxjs';

import { ButtonPosition, ButtonTheme, NotificationTheme } from '@fcom/ui-components/index';
import { FinnairBoundItem, FinnairCodeAndName, FinnairOrder } from '@fcom/dapi/api/models';
import { isFlight } from '@fcom/common-booking/utils/common-booking.utils';

@Component({
  selector: 'fin-check-in-restricted-items',
  templateUrl: 'check-in-restricted-items.component.html',
  styleUrls: ['./check-in-restricted-items.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CheckInRestrictedItemsComponent implements OnInit {
  readonly SvgLibraryIcon = SvgLibraryIcon;
  readonly ButtonPosition = ButtonPosition;
  readonly ButtonTheme = ButtonTheme;

  @Input() order$: Observable<FinnairOrder>;

  @Input() bound$: Observable<FinnairBoundItem>;

  @Input() buttonLoading$: Observable<boolean>;

  @Output() confirmStep: EventEmitter<void> = new EventEmitter<void>();

  carrierConnectAirline$: Observable<FinnairCodeAndName>;

  ngOnInit(): void {
    this.carrierConnectAirline$ = combineLatest([this.order$, this.bound$]).pipe(
      map(([order, bound]) => {
        const isCarrierConnect = order?.eligibilities?.checkIn?.find((e) => e.id === bound.id)?.isCarrierConnect;

        if (isCarrierConnect) {
          return bound?.itinerary?.filter(isFlight)[0]?.operatingAirline;
        }

        return null;
      }),
      filter(Boolean)
    );
  }

  protected readonly NotificationTheme = NotificationTheme;
}
